import { useEffect, useState } from "react";

const useIdleTimer = (
  timeoutSeconds: number,
  isInactiveTimer: boolean,
  handleOpenInactiveModal: () => void
): boolean => {
  const timeout = timeoutSeconds * 1000;
  const [isIdle, setIsIdle] = useState<boolean>(false);

  useEffect(() => {
    let timer: NodeJS.Timeout;

    const resetTimer = () => {
      setIsIdle(false);
      clearTimeout(timer);
      timer = setTimeout(() => {
        handleOpenInactiveModal();
        setIsIdle(true);
      }, timeout);
    };

    const events: Array<keyof WindowEventMap> = [
      "mousemove",
      "keypress",
      "click",
      "scroll",
      "touchstart",
    ];

    if (isInactiveTimer) {
      events.forEach((event) => window.addEventListener(event, resetTimer));
      resetTimer();
    }

    return () => {
      clearTimeout(timer);
      if (isInactiveTimer) {
        events.forEach((event) =>
          window.removeEventListener(event, resetTimer)
        );
      }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeout, isInactiveTimer]);

  return isIdle;
};

export default useIdleTimer;
